import React, { Component } from "react";
import config from "lib/fr-config";
import { getDeviceType } from "lib/deviceInfo";

const UPPER_PADING_PERCENT = 0.5;

const desktopCss = config.css.desktop;
const mobileCss = config.css.mobile;

class FloatingBoxView extends Component {
  state = {
    boxHeight: 0
  };

  forceRenderUpdateForSafari() {
    /**
     * 사파리에서 렌더직후 폰트 로딩등의 이유로 box의 높이가 달라지는 문제점때문에 추가한 임시코드.
     * loop 함수 실행중 box의 높이 변경되면 바로 state에 적용되도록 강제하는 함수.
     * (근데 사파리 아니라도 랜더중 box 생성되지 않았을 경우(boxHeight 가 0으로 설정된 후)
     * 후에 생성된 box의 높이를 다시 재는 목적으로도 사용되는듯 하다.)
     */
    let LOOP_COUNT = 20;
    let LOOP_MILLISEC = 20;
    const that = this;

    const mainFunction = () => {
      that.setBoxHeight();
      loopFunction();
    };

    const loopFunction = () => {
      if (LOOP_COUNT <= 0) return null;
      else {
        LOOP_COUNT = LOOP_COUNT - 1;
        window.setTimeout(mainFunction, LOOP_MILLISEC);
      }
    };

    mainFunction();
  }

  getCss() {
    const { boxHeight } = this.state;
    const deviceType = getDeviceType();
    const fullHeight = deviceType === "mobile" ? "100dvh" : "100vh";
    const headerHeight =
      deviceType === "mobile"
        ? mobileCss.logoBarHeightPX + mobileCss.headerBarHeightPX
        : desktopCss.headerBarHeightPX;
    const paddingTop = `calc( ( ${fullHeight} - ${headerHeight}px - ${
      boxHeight || 0
    }px - env(safe-area-inset-bottom) ) / ( 1 / ${UPPER_PADING_PERCENT} )`;
    const marginTop =
      deviceType === "mobile"
        ? -mobileCss.paddingBetweenHeaderbarAndFirstContent
        : -desktopCss.paddingBetweenHeaderbarAndFirstContent;

    return {
      root: { maxWidth: 300, margin: "auto", marginTop, paddingTop },
      buttonArea: { marginTop: 50 }
    };
  }

  setBoxHeight() {
    const { box } = this;
    const { boxHeight } = this.state;
    const newBoxHeight = box ? box.clientHeight : 0;
    if (Math.abs(boxHeight - newBoxHeight) < 5) return null;
    this.setState({ boxHeight: newBoxHeight });
  }

  render() {
    const { children } = this.props;
    const css = this.getCss();

    return (
      <div style={css.root}>
        <div ref={ref => (this.box = ref)}>{children}</div>
      </div>
    );
  }

  componentDidMount() {
    this.setBoxHeight();
    this.forceRenderUpdateForSafari();
  }
}

export default FloatingBoxView;
